import React from "react";
import { Box } from "@mui/system";

import { MzRadio, MzRadioGroup } from "@markaaz/ui/MzRadioControls";

const sx = {
  card: {
    border: "none",
    marginBottom: "2px",
    display: "flex",
    flexDirection: "row",
    borderRadius: "5px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    backgroundColor: (theme) => theme.palette.common.white,
    height: "70px",
    maxWidth: "800px"
  },
  label: {
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    color: (theme) => theme.palette.darkBlue.c100,
    flex: 2
  },
  chipWrapper: {
    display: "flex",
    flex: 2,
    gap: "15px",
    alignItems: "center"
  }
};

export default function ThresholdRow({ label = "", options = [], key = "", value = "", onChange, disabled }) {
  return (
    <Box sx={sx.card} key={`tile-${key}`}>
      <Box sx={sx.label}>{label}</Box>
      <Box sx={sx.chipWrapper}>
        <MzRadioGroup row chip value={value} onChange={onChange} disabled>
          {options.map((option) => {
            return (
              <MzRadio
                key={option?.key}
                value={option?.value}
                label={option?.label}
                sx={{ "& .MuiChip-root": { width: 80 } }}
              />
            );
          })}
        </MzRadioGroup>
      </Box>
    </Box>
  );
}
